export default __webpack_public_path__ + "images/desktop-start2-58ee0f.svg";